import { NgModule } from '@angular/core';
import { ThreePanelComponent } from './three-panel.component';

export { ThreePanelComponent } from './three-panel.component';

export const MODULE_IMPORTS_AND_EXPORTS = [ThreePanelComponent];

@NgModule({
  imports: MODULE_IMPORTS_AND_EXPORTS,
  exports: MODULE_IMPORTS_AND_EXPORTS,
})
export class GalaxyThreePanelModule {}
